import clsx from 'clsx'
import {useEffect, useRef, useState} from 'react'

import SynthesizeButton from './SynthesizeButton'
import {delay} from '~/utils/delay'

type Props = React.PropsWithChildren<{
    className?: string
    activeExample?: string
    setActiveExample?: (example: string) => void
}>

export default function ExampleCode({children, activeExample, setActiveExample, className}: Props) {
    const codeRef = useRef<HTMLElement>(null)
    const [copied, setCopied] = useState(false)
    const [textContent, setTextContent] = useState('')

    useEffect(() => {
        setTextContent((codeRef.current?.textContent || '').replace(/[\t]+/g, ''))
    }, [])

    const copyText = () => navigator.clipboard.writeText(textContent)
        .then(() => setCopied(true))
        .then(() => delay(2000))
        .then(() => setCopied(false))

    return <code ref={codeRef} className={clsx('code', className)}>
        <div data-copied={copied || undefined} className='code__buttons'>
            <button
                type='button'
                disabled={copied}
                className='pi pi-clone code__button'
                onClick={copyText}
            />
            {setActiveExample &&
                <SynthesizeButton
                    text={textContent}
                    active={activeExample == textContent}
                    onActivate={() => setActiveExample(textContent)}
                />
            }
        </div>
        {children}
    </code>
}
